module.exports = __webpack_public_path__ + "static/img/skyline-left-min.f05b9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/skyline-left-min.png
// module id = 681
// module chunks = 64